import {MatchStatus} from "./league-competitor";
import {ListSortOrder} from "../list-sort-order";

export class LeagueCompetitorFilter {

    constructor(
        public searchTerm?: string,
        public gender?: number,
        public matchStatuses?: MatchStatus[],
        public eventIds?: number[],
        public raceIds?: number[],
        public categories?: number[],
        public countries?: number[],
        public sortBy?: LeagueCompetitorsSortBy,
        public sortOrder?: ListSortOrder
        ) {
    }
}


export enum LeagueCompetitorsSortBy {
    ID,
    NAME,
    COUNTRY,
    SEX,
    MATCH_STATUS,
    CATEGORY,
    CREATED,
    MODIFIED
}